import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../config";

export const userProductShow = createAsyncThunk(
  "product/user-product/show",
  async (titleKey) => {
    const response = await fetch(`${config.apiBaseUrl}/user-product-show`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        titleKey: titleKey,
      }),
    });

    const result = await response.json();
    console.log(result);
    return result;
  },
);

export const prodDetails = createAsyncThunk("product/details", async (slug) => {
  const response = await fetch(`${config.apiBaseUrl}/details/${slug}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const result = await response.json();

  return result;
});

const productSlice = createSlice({
  name: "products",
  initialState: {
    product: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userProductShow.pending, (state) => {
        state.status = "loading";
      })
      .addCase(userProductShow.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.product = action.payload;
      })
      .addCase(userProductShow.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(prodDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(prodDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.product = action.payload;
      })
      .addCase(prodDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default productSlice.reducer;
